export default __webpack_public_path__ + "static/media/client-15.ea5fca31.webp";